import { render } from "./Workshifts.vue?vue&type=template&id=91abcbca"
import script from "./Workshifts.vue?vue&type=script&lang=js"
export * from "./Workshifts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__